module.exports = __webpack_public_path__ + "img/app-store-01@2x.c03c4ccd.png";